module.exports = __webpack_public_path__ + "static/img/14000770.833bcb15.png";